import PropTypes from 'prop-types';

const TemplatePageSidePanelPropTypes = {
  children: PropTypes.node.isRequired,
};

export default TemplatePageSidePanelPropTypes;
